import { Image } from "antd";
import React from "react";

import CommingSoonImage from "assets/images/png/logo.jpg";

export default function ComingSoon() {
  return (
    <div
      style={{
        fontSize: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
        background: "linear-gradient(180deg, rgba(144,199,197,1) 0%, rgba(218,239,237,1) 50%)",
      }}
    >
      <center style={{ backgroundColor: "rgba(0,0,0,0.5)", padding: 20, color: "white", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 30, width: "100%", height: "100%" }}>
        {/* <div>Feature</div> */}
        <div>
          <h2 style={{ margin: 0 }}>พบกันเร็วๆ นี้</h2>
        </div>

        <div>
          <div style={{ borderRadius: "50%", width: 100, height: 100, padding: 10, overflow: "hidden", background: "white", marginBottom: 10 }}>
            <Image preview={false} src={CommingSoonImage} width={"100%"} />
          </div>
          <div>CADDIE DEE</div>
        </div>
      </center>
    </div>
  );
}
